export default {
	game: {
		maintenance: 'En Mantenimiento',
		maintenance_tip: 'Temporalmente no disponible',
		no_more_data: 'No hay más datos',
		search_game_name: 'Buscar nombre del juego...',
		selected: 'Seleccionado',
		type: 'Tipo',
		all_types: 'Todos los Tipos',
		secondary: 'Secundario',
		secondary_category: 'Categoría Secundaria',
		no_related_games: 'No se encontraron juegos relacionados',
		reset_all: 'Restablecer Todo',
		end_of_list: 'Fin de la Lista',
		game_details: 'Detalles del Juego',
		play: 'Jugar',
		bonus_cannot_wagered: 'El bono no se puede apostar',
		entering_game: 'Entrando al juego, por favor espera...',
		entering_game_short: 'Entrando al Juego...',
		game_types: 'Tipos de Juego',
		game_providers: 'Proveedores de Juegos',
		sign_up: 'Registrarse',
		search: 'Buscar',
		all_providers: 'Todos los Proveedores',
		loading: 'Cargando...',
		my_bet: 'Mi Apuesta'
	}
};